module.exports = __webpack_public_path__ + "img/moon-of-appalacia.08b23caf.jpg";